import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "contact-div",
  class: "contact-container"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-angle-left middle-left clickable" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "contact-formulaire" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  id: "map",
  style: {"width":"100%","height":"33vh"},
  class: "fade-in-right"
}, [
  /*#__PURE__*/_createElementVNode("iframe", {
    src: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3149.9329241356754!2d-1.5386284495657188!3d47.2141955380375!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4805eec62fa1937f%3A0xeb5d5794e2edd417!2s4%20Rue%20de%20l'Indre%2C%2044000%20Nantes!5e0!3m2!1sfr!2sfr!4v1651703203810!5m2!1sfr!2sfr",
    width: "100%",
    height: "100%",
    style: {"border":"0"},
    allowfullscreen: "",
    loading: "lazy",
    referrerpolicy: "no-referrer-when-downgrade"
  })
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h3", { class: "title-contact fade-in" }, [
  /*#__PURE__*/_createTextVNode(" Vous avez une question ? Vous souhaitez me contacter ? "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" N'hésitez pas à me contacter ! ")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "fade-in" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" Ou contactez moi directement par "),
    /*#__PURE__*/_createElementVNode("a", { href: "mailto:conseilplr@gmail.com" }, "mail")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToSkillPage()))
    }, _hoisted_3),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _hoisted_6,
      _createVNode(_component_FormKit, {
        type: "form",
        "submit-label": "Envoyer",
        onSubmit: _ctx.submit,
        class: "fade-in"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_FormKit, {
            class: "contact-form-input fade-in",
            label: "Téléphone",
            name: "tel",
            placeholder: "+33 6 XX XX XX XX"
          }),
          _createVNode(_component_FormKit, {
            class: "contact-form-input fade-in",
            name: "email",
            label: "Email",
            placeholder: "@"
          }),
          _createVNode(_component_FormKit, {
            class: "contact-form-input message-input fade-in",
            type: "textarea",
            name: "message",
            label: "Message",
            placeholder: "Votre message"
          })
        ]),
        _: 1
      }, 8, ["onSubmit"]),
      _hoisted_7
    ])
  ]))
}